/* Ads-only remarketing through the app's existing gtag. No transport or tag setup. */
(function () {
  'use strict';
  if (window.ChaponAdsRemarketing) return;
  const node = document.querySelector('[data-ads-remarketing-config]');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const destination = config.destination?.trim();
  if (!/^AW-\d+$/.test(destination) || !/^[A-Z]{2}$/.test(config.country)) return;
  const key = 'chapon:ads-remarketing';
  const lifetime = 120000;
  const cart = config.cart || [];
  const total = (lines, id) => lines.filter(line => String(line.variantId) === String(id)).reduce((sum, line) => sum + Number(line.quantity), 0);
  const read = () => {
    try { const records = JSON.parse(sessionStorage.getItem(key) || '[]'); return Array.isArray(records) ? records : []; }
    catch (_) { return []; }
  };
  const write = records => {
    try { sessionStorage.setItem(key, JSON.stringify(records)); return true; } catch (_) { return false; }
  };
  const remove = id => write(read().filter(record => record.id !== id));
  const valid = record => record && record.destination === destination && record.country === config.country && record.currency === config.currency && Date.now() - record.time >= 0 && Date.now() - record.time < lifetime;
  function record(fields) {
    const entry = { ...fields, id: crypto.randomUUID(), time: Date.now(), destination, country: config.country, currency: config.currency };
    entry.stored = write([...read().filter(valid), entry]);
    return entry;
  }
  function parameters(line, quantity = 1, name = 'view_item') {
    const price = Number(line.price), count = Number(quantity);
    if (!/^\d+$/.test(String(line.productId)) || !/^\d+$/.test(String(line.variantId)) || !Number.isFinite(price) || price < 0 || !Number.isSafeInteger(count) || count < 1) return;
    return {
      send_to: destination,
      value: name === 'add_to_cart' ? 0 : price / 100,
      items: [{ id: `shopify_${config.country}_${line.productId}_${line.variantId}`, google_business_vertical: 'retail' }]
    };
  }
  function send(name, params, entry) {
    if (!params) { if (entry) remove(entry.id); return; }
    // Also preserve the published value for events queued by an earlier script version.
    if (name === 'add_to_cart') params = { ...params, value: 0 };
    let attempts = 0;
    const attempt = () => {
      // Claim persisted events before gtag: reload/BFCache must never replay an add.
      if (entry?.stored && !read().some(record => record.id === entry.id)) return;
      if (typeof window.gtag === 'function') {
        if (entry?.stored && !remove(entry.id)) return;
        try { window.gtag('event', name, params); } catch (_) { /* Measurement never blocks shopping; do not retry an ambiguous send. */ }
      } else if (++attempts < 60) {
        setTimeout(attempt, 250);
      } else if (entry) remove(entry.id);
    };
    attempt();
  }
  function remember(variantId, quantity) {
    if (!/^\d+$/.test(String(variantId)) || !Number.isSafeInteger(Number(quantity)) || Number(quantity) < 1) return;
    try {
      // Only one native navigation can be pending; app FormData inspection may fire repeatedly.
      write(read().filter(entry => valid(entry) && entry.kind !== 'native'));
      record({ kind: 'native', variantId: String(variantId), quantity: Number(quantity), before: total(cart, variantId) });
    } catch (_) { /* Optional storage must not interrupt native submission. */ }
  }
  function cancelNative(requested) {
    try {
      write(read().filter(entry => valid(entry) && (entry.kind !== 'native' || !requested.some(item => String(item.id) === entry.variantId))));
    } catch (_) { /* An Ajax failure must not leave a native-navigation intent. */ }
  }
  function added(lines, requested, primaryVariantId) {
    try {
      cancelNative(requested);
      const selected = primaryVariantId ? requested.filter(item => String(item.id) === String(primaryVariantId)) : requested;
      for (const item of selected) {
        const line = lines.find(line => String(line.variant_id || line.id) === String(item.id));
        if (!line) continue;
        // Keep the baseline current if a native add follows an Ajax add on this page.
        const existing = cart.filter(item => String(item.variantId) === String(line.variant_id || line.id));
        if (existing.length) existing[0].quantity = Number(existing[0].quantity) + Number(item.quantity);
        else cart.push({ variantId: item.id, quantity: Number(item.quantity) });
        const params = parameters({ productId: line.product_id, variantId: line.variant_id || line.id, price: line.price }, item.quantity, 'add_to_cart');
        if (params) {
          const entry = record({ kind: 'confirmed', params });
          send('add_to_cart', params, entry);
        }
      }
    } catch (_) { /* Optional measurement cannot reject a successful cart add. */ }
  }
  window.ChaponAdsRemarketing = Object.freeze({ remember, cancelNative, added });
  // Native submit(), requestSubmit(), and app-owned POSTs all construct form data.
  // Unlike a submit listener this also sees apps that bypass the submit event.
  document.addEventListener('formdata', event => {
    try {
      const form = event.target;
      if (!form.matches('[data-product-form], [data-cart-quick-add]')) return;
      const data = event.formData;
      let id = data.get('id'), quantity = data.get('quantity') || 1;
      if (!id) {
        const product = form.closest('chapon-product');
        const variants = product ? JSON.parse(product.querySelector('[data-product-config]').textContent).variants : [];
        for (const [name, value] of data.entries()) {
          const match = /^items\[(\d+)\]\[id\]$/.exec(name);
          if (match && (!variants.length || variants.some(variant => String(variant.id) === String(value)))) {
            id = value; quantity = data.get(`items[${match[1]}][quantity]`) || 1; break;
          }
        }
      }
      remember(id, quantity);
    } catch (_) { /* Storage/app form differences are non-fatal. */ }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) write(read().filter(entry => valid(entry) && entry.kind !== 'native'));
  });
  const pending = read();
  write(pending.filter(valid));
  for (const entry of pending.filter(valid)) {
    entry.stored = true;
    if (entry.kind === 'native') {
      const line = cart.find(line => String(line.variantId) === entry.variantId);
      if (!line || total(cart, entry.variantId) < entry.before + entry.quantity) { remove(entry.id); continue; }
      entry.kind = 'confirmed';
      entry.params = parameters(line, entry.quantity, 'add_to_cart');
      write(read().map(record => record.id === entry.id ? entry : record));
    }
    // Never trust a stored destination, even if storage was edited or settings changed.
    if (entry.kind === 'confirmed' && entry.params?.send_to === destination) send('add_to_cart', entry.params, entry);
    else remove(entry.id);
  }
  if (config.product) send('view_item', parameters(config.product));
})();
